import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Calendar } from 'lucide-react';
import api from '../../request';  // Make sure path is correct

const ActivityChart = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchWeeklyData = async () => {
      try {
        const response = await api.get('/user/weekly-activity');
        setData(response.data);
      } catch (error) {
        console.error('Failed to fetch activity data:', error);
      }
    };

    fetchWeeklyData();
  }, []);

  const average = data.length ? Math.round(data.reduce((sum, day) => sum + day.steps, 0) / data.length) : 0;
  const bestDay = data.reduce((prev, curr) => (curr.steps > prev.steps ? curr : prev), { steps: 0 });

  return (
    <div className="bg-white rounded-xl shadow-sm p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <Calendar size={24} className="text-primary" />
          <h3 className="text-lg font-medium">Weekly Activity</h3>
        </div>
        
      </div>

      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="day" axisLine={false} tickLine={false} />
            <YAxis 
              axisLine={false} 
              tickLine={false} 
              tickFormatter={(value) => value === 0 ? '' : `${value / 1000}k`}
            />
            <Tooltip 
              formatter={(value) => [value.toLocaleString(), 'Steps']}
              labelFormatter={(label) => `${label}`}
              contentStyle={{ borderRadius: '8px' }}
            />
            <Bar 
              dataKey="steps" 
              fill="#4CAF50" 
              radius={[4, 4, 0, 0]} 
              animationDuration={1500}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="flex justify-between items-center mt-4 text-sm text-gray-500">
        <div>
          <span className="block font-medium">Average: </span>
          <span>{average.toLocaleString()} steps</span>
        </div>
        <div>
          <span className="block font-medium">Best day: </span>
          <span>{bestDay.day} ({bestDay.steps.toLocaleString()})</span>
        </div>
      </div>
    </div>
  );
};

export default ActivityChart;
